﻿import * as _ from "lodash";

import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "dataFilter"
})
export class DataFilterPipe implements PipeTransform {

    arrquery: any[];
    temparray: any[];

    transform(array: any[], query: string): any {

        this.arrquery = query.split(",");
        this.temparray = array;
        for (var qry in this.arrquery) {
            var qryvalue = this.arrquery[qry];
            if (qryvalue && qryvalue != "undefined") {
                qryvalue = qryvalue.toUpperCase();
                if (qry == "0") {
                    this.temparray = _.filter(this.temparray, ( row ) => (row.HearingDateTime.indexOf(qryvalue) > -1));
                }
                if (qry == "1") {
                    this.temparray = _.filter(this.temparray, ( row ) => (row.HearingType.toUpperCase().indexOf(qryvalue) > -1));
                }
                if (qry == "2") {
                    this.temparray = _.filter(this.temparray, ( row ) => (row.CaseDisplayNumber.toUpperCase().indexOf(qryvalue) > -1));
                }
                if (qry == "3") {
                    this.temparray = _.filter(this.temparray, ( row ) => (row.FirstName.toUpperCase().indexOf(qryvalue) > -1));
                }
                if (qry == "4") {
                    this.temparray = _.filter(this.temparray, ( row ) => (!!row.MiddleName ? row.MiddleName.toUpperCase().indexOf(qryvalue) > -1 : row));
                }
                if (qry == "5") {
                    this.temparray = _.filter(this.temparray, ( row ) => (row.LastName.toUpperCase().indexOf(qryvalue) > -1));
                }
                if (qry == "6") {
                    this.temparray = _.filter(this.temparray, ( row ) => (row.DOB.indexOf(qryvalue) > -1));
                }
            }
        }
        return this.temparray;
    }

}





